import { styled } from 'dripsy';
import React, { Fragment } from 'react';
import { View } from 'react-native';

import { Separator } from '../common/Separator';
import { BaseText } from '../common/BaseText';
import { ISwitchProps, Switch } from '../common/Switch';

const Container = styled(View)({
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
});

const Title = styled(BaseText)({
  variant: 'text.xlarge',
  color: '$heading800',
});

export interface ISwitchItemProps extends ISwitchProps {
  title: string;
}

export function SwitchItem({ title, ...props }: ISwitchItemProps) {
  return (
    <Fragment>
      <Separator size="$8" />
      <Container>
        <Title>{title}</Title>
        <Switch {...props} />
      </Container>
      <Separator size="$8" />
    </Fragment>
  );
}
